// extracted by mini-css-extract-plugin
var _1 = "SettingsSwitchField-modulelabel__UcofD SettingsField-modulelabel__GYdiy Field-modulelabel__b72si";
export { _1 as "label" }
